import Controller from "@ember/controller";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";

export default class extends Controller {
  @service declare router: RouterService;

  transitionToIndex = (): void => {
    this.router.transitionTo("index");
  };
}
